import type { HTMLAttributes, ReactNode } from 'react';
import React from 'react';
import { Heading } from '$quantum/atoms/Heading';
import { HeadingLevels } from '../../../src/components/atoms/HeadingLevels';

export interface HeadingsProps extends HTMLAttributes<HTMLElement> {
  readonly heading: ReactNode;
  readonly subheading?: string;
  readonly className?: string;
}

/**
 * Grouping `Heading` and `Subheading` under a `header` tag.
 */
/** @deprecated Use HeadingLevels component */
export function Headings({ heading, subheading, ...props }: HeadingsProps): JSX.Element {
  return (
    <header {...props}>
      <Heading>{heading}</Heading>
      {subheading && (
        <HeadingLevels semanticLevel={3} styleLevel={3}>
          {subheading}
        </HeadingLevels>
      )}
    </header>
  );
}
Headings.displayName = 'Headings';
